import type { SwiperOptions } from 'swiper/types';

export const swiperConfig: SwiperOptions = {
  watchOverflow: true,
  watchSlidesProgress: true,
  resizeObserver: true,
  slidesPerView: 1,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  breakpoints: {
    320: {
      shortSwipes: true,
      spaceBetween: 16,
    },
    992: {
      shortSwipes: false,
    },
  },
};

export const swiperThumbsConfig: SwiperOptions = {
  slidesPerView: 'auto',
  allowTouchMove: true,
  watchOverflow: true,
  watchSlidesProgress: true,
  direction: 'vertical',
  mousewheel: true,
  threshold: 20,
  breakpoints: {
    992: {
      spaceBetween: 8,
    },
  },
};
